module.exports = __webpack_public_path__ + "e4867fd26b7a44322daac69dfffb4994.png";